var fn = function( obj ){
var __t,__p='';
__p+='\nvarying vec2 vTexCoord0;\nuniform sampler2D tMain;\nuniform sampler2D tMask;\nuniform sampler2D tLines;\n\nuniform vec3 uWaveColor;\n\nvoid main(void){\n  vec2 mask = texture2D( tMask, vTexCoord0 ).rg;\n  vec4 color = texture2D( tMain, vTexCoord0 );\n  vec4 lines = texture2D( tLines, vTexCoord0 );\n\n  float alpha = mask.g * color.a;\n  gl_FragColor = vec4( color.rgb * alpha + uWaveColor*mask.r*2.0 + lines.rgb, alpha );\n  // gl_FragColor = gl_FragColor*0.000000001+color;\n}\n';
return __p;
};
fn.toString=fn;
module.exports = fn;